export default __webpack_public_path__ + "static/media/subcategories-icon.cf2ed3d0.svg";